import Env from "../env";
import axios from "axios";

export const api = axios.create({
  baseURL: `${Env.API_URL}`,
  withCredentials: true,
});

// Session SAV (SavLogin) : le login SAV, saisi dans la page (la fenêtre de login native
// n'apparaît pas sur Safari pour un appel vers une autre adresse), est échangé contre un jeton
// de 12 h (/sav/session). Seul le jeton est gardé, dans localStorage pour rester connecté entre
// les onglets et après fermeture du navigateur ; le mot de passe n'est jamais stocké.
const SAV_SESSION_KEY = "savSession";

type SavSession = {token: string; expires_at: number};

export const savAuth = {
  get: (): SavSession | null => {
    try {
      return JSON.parse(localStorage.getItem(SAV_SESSION_KEY) ?? "null");
    } catch (e) {
      return null;
    }
  },
  isActive: (): boolean => (savAuth.get()?.expires_at ?? 0) > Date.now(),
  set: (session: SavSession) => {
    try {
      localStorage.setItem(SAV_SESSION_KEY, JSON.stringify(session));
    } catch (e) {}
  },
  clear: () => {
    try {
      localStorage.removeItem(SAV_SESSION_KEY);
    } catch (e) {}
    window.dispatchEvent(new Event("sav-auth-lost"));
  },
};

export const basicAuthHeader = (login: string, password: string): string => {
  let binary = "";
  new TextEncoder()
    .encode(`${login}:${password}`)
    .forEach((b) => (binary += String.fromCharCode(b)));
  return `Basic ${btoa(binary)}`;
};

// Toujours un en-tête sur /sav/, même sans session ou avec un jeton expiré : sans en-tête, une
// route protégée répond 401 + WWW-Authenticate et Chrome ouvre sa fenêtre de login native. Un
// jeton refusé reçoit un 401 simple, qui ramène au formulaire.
api.interceptors.request.use((config) => {
  if (config.url?.startsWith("/sav/") && !config.headers.has("Authorization")) {
    config.headers.set(
      "Authorization",
      `Bearer ${savAuth.get()?.token ?? "none"}`
    );
  }
  return config;
});

// defining a custom error handler for all APIs
const errorHandler = (error: any) => {
  const statusCode = error.response?.status;

  if (error.code === "TO_DEFINE") {
    return Promise.resolve();
  }

  if (statusCode === 401 && error.config?.url?.startsWith("/sav/")) {
    savAuth.clear();
  }

  if (statusCode && statusCode !== 401) {
    console.error(error);
  }

  return Promise.reject(error);
};

api.interceptors.response.use(undefined, (error) => {
  return errorHandler(error);
});
